import styled from "styled-components";
import { FONTS } from "../../../styles/fonts";
import { COLORS } from "../../../styles/colors";
import { media } from "../../../styles/media";

export const DonioSuperWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 50px;
`;

export const DonioWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${COLORS.third};
  padding: 15px;
  max-width: calc(100% - 30px);

  ${media.md`
    max-width: 700px;
      padding: 50px;
    `}
`;

export const DonioTitle = styled.div`
  font-family: ${FONTS.primary};
  color: ${COLORS.black};
  font-size: 35px;
  letter-spacing: 1.2px;
  line-height: 2.5rem;
  text-align: center;
`;

export const Text = styled.div`
  font-family: ${FONTS.primary};
  font-size: 18px;
  letter-spacing: 1.2px;
  margin-top: 35px;
  line-height: 2.5rem;
`;

export const DonioLink = styled.a`
  font-family: ${FONTS.primary};
  font-size: 18px;
  letter-spacing: 1.2px;
  margin-top: 35px;
  line-height: 2.5rem;
`;

export const DonioImage = styled.img`
  max-width: 100%;
  height: auto;
`;
